import * as React from 'react';

import styled from 'styled-components';

import { SPACING, FONT_SIZE, COLOR } from '../../packages/constants';
import { MonthDatePicker, MonthDatePickerProps } from '../month-date-picker';

export interface MonthDatePickerFieldProps extends MonthDatePickerProps {
    label: string;
    validationMessage?: string;
    thinLabel?: boolean;
}

interface StyledTextLabelProps {
    disabled?: boolean;
    invalid?: boolean;
    thinLabel?: boolean;
}

interface StyledValidationMessageProps {
    invalid?: boolean;
}

const StyledTextLabel = styled.label<StyledTextLabelProps>`
    display: inline-block;
    padding-bottom: ${SPACING.XX_SMALL};
    margin-right: ${SPACING.X_SMALL};
    font-size: ${FONT_SIZE.SMALL};
    line-height: ${FONT_SIZE.MEDIUM};
    font-weight: ${(props: StyledTextLabelProps): string => (props.thinLabel ? '400' : '700')};
    color: ${(props: StyledTextLabelProps): string => (props.invalid ? COLOR.PRIMARY.RED : COLOR.MAIN.LABEL_TEXT)};
    opacity: ${(props: StyledTextLabelProps): string => (props.disabled ? '0.7' : '1')};
`;

const StyledValidationMessage = styled.div<StyledValidationMessageProps>`
    font-size: ${FONT_SIZE.X_SMALL};
    line-height: ${FONT_SIZE.SMALL};
    color: ${(props: StyledValidationMessageProps): string =>
        props.invalid ? COLOR.PRIMARY.RED : COLOR.PRIMARY.BLACK};
    padding-top: ${SPACING.SMALL};
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const MonthDatePickerField = React.forwardRef<HTMLButtonElement, MonthDatePickerFieldProps>(
    ({ disabled, invalid, label, validationMessage, thinLabel, ariaLabel, ...props }, ref) => {
        return (
            <>
                <StyledTextLabel disabled={disabled} invalid={invalid} thinLabel={thinLabel}>
                    {label}
                </StyledTextLabel>
                <MonthDatePicker
                    disabled={disabled}
                    invalid={invalid}
                    ariaLabel={ariaLabel ?? label}
                    ref={ref}
                    {...props}
                />
                {validationMessage && (
                    <StyledValidationMessage invalid={invalid}>{validationMessage}</StyledValidationMessage>
                )}
            </>
        );
    },
);
MonthDatePickerField.displayName = 'MonthDatePickerField';
